module.exports = __webpack_public_path__ + "img/9.2cd49269.svg";